import { css } from '@lastbrand/web-ui-styled-system/css'

// Panda twin of productInfo.module.scss; legacy is fluid-rem (~10px root), sizes mapped by intended px.

export const containerCss = css({
  width: 'inherit',
})

// The margin variants below are mutually exclusive (picked in product-info-ds.tsx);
// stacking them as overrides is unreliable because Panda emits one class per
// property value and their stylesheet order is not the cx() order.
export const containerSpacingCss = css({
  mb: 'space-20',
})

export const containerUpdatedDesignV2Css = css({
  mb: 'space-24',
})

export const containerThirdPartyCss = css({
  mb: 'space-20',
})

export const containerNewDesignV2BundleCss = css({
  mb: 0,
})

export const containerBrandNameCss = css({
  textStyle: 'body-12',
  lineHeight: '18px', // legacy 1.8rem
  fontWeight: 500,
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  color: 'mediumgray',
  mb: { base: 'space-10', lg: 'space-4' },
  borderBottom: '1px solid transparent',
  display: 'inline-block',
  _hover: {
    color: 'black',
    borderBottom: '1px solid token(colors.black)',
  },
})

export const containerBrandNameWithoutLinkCss = css({
  textStyle: 'body-12',
  lineHeight: '18px', // legacy 1.8rem
  fontWeight: 500,
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  color: 'mediumgray',
  mb: { base: 'space-10', lg: 'space-4' },
  borderBottom: '1px solid transparent',
  display: 'inline-block',
})

export const containerHeaderCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 'space-24',
  pb: 'space-12',
  // Fill the form column so the title stays on one line.
  width: 'full',
})

export const containerHeaderUpdatedDesignV2Css = css({
  pb: 'space-12',
})

// No textStyle here: `_adjustedPadding` (always applied) owns the font; a second textStyle
// races it by stylesheet source order (not cx order) and rendered the title serif/24px (wrapping).
export const containerHeaderTextCss = css({
  fontStyle: 'normal',
  fontWeight: 400,
  // Desktop sizes to content (flex-shrinks within the column) so the title stays on one line.
  width: { base: '316px', lg: 'auto' },
})

export const containerHeaderTextAdjustedPaddingCss = css({
  textStyle: { base: 'body-16', lg: 'body-20' },
  lineHeight: { base: '22px', lg: '24px' },
})

export const containerHeaderTextNewDesignV2ReviewSummaryNotVisibleCss = css({
  width: '100%',
  maxWidth: '100%',
})

export const containerHeaderIconCss = css({
  marginTop: 'space-4',
  cursor: 'pointer',
  display: { base: 'none', lg: 'block' },
})

export const reviewWrapperCss = css({
  display: 'flex',
  alignItems: 'center',
  mb: 'space-24',
  cursor: 'pointer',
})

export const reviewRatingCss = css({ position: 'relative' })

export const reviewStarIconCss = css({ height: '13px', width: '14px' })

export const reviewCountCss = css({
  textStyle: 'body-12',
  lineHeight: '18px', // legacy 1.8rem
  fontWeight: 500,
  letterSpacing: '2px',
  textTransform: 'uppercase',
  color: 'black', // DS black token is #21201F
  ml: 'space-4',
  '& span': {
    borderBottom: '1px solid token(colors.black)',
    display: 'inline-block',
    mb: '2px',
  },
})

export const reviewWrapperUpdatedDesignV2Css = css({
  mb: 'space-20',
})
